import { SonanNewMessageChecker } from "./chat/SonanNewMessageChecker";


window.bootstrap = require('bootstrap');
window.AOS = require('aos');

window.SonanAudioHandler = require('./audio/SonanAudioHandler');
window.SonanNewMessageChecker = SonanNewMessageChecker;


AOS.init({startEvent: 'DOMContentLoaded', disable: 'mobile'});
